import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "onDismiss", "onEscape", "ignoreEscape", "ignoreBackdropClick", "hideBackdrop", "rootClassName", "className", "style", "backdropClassName", "disabledScrollLock", "disabledFocusLock", "children", "dark", "htmlProps"];
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import cn from 'classnames';
import { KEY_NAMES } from "../helpers/constants";
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated
 * This component should not be used. Use <Drawer position="bottom" /> instead.
 */
var BottomSheet = function BottomSheet(_ref) {
  var _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    onDismiss = _ref.onDismiss,
    onEscape = _ref.onEscape,
    _ref$ignoreEscape = _ref.ignoreEscape,
    ignoreEscape = _ref$ignoreEscape === void 0 ? false : _ref$ignoreEscape,
    _ref$ignoreBackdropCl = _ref.ignoreBackdropClick,
    ignoreBackdropClick = _ref$ignoreBackdropCl === void 0 ? false : _ref$ignoreBackdropCl,
    _ref$hideBackdrop = _ref.hideBackdrop,
    hideBackdrop = _ref$hideBackdrop === void 0 ? false : _ref$hideBackdrop,
    _ref$rootClassName = _ref.rootClassName,
    rootClassName = _ref$rootClassName === void 0 ? '' : _ref$rootClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    style = _ref.style,
    _ref$backdropClassNam = _ref.backdropClassName,
    backdropClassName = _ref$backdropClassNam === void 0 ? '' : _ref$backdropClassNam,
    disabledScrollLock = _ref.disabledScrollLock,
    disabledFocusLock = _ref.disabledFocusLock,
    children = _ref.children,
    dark = _ref.dark,
    htmlProps = _ref.htmlProps,
    bottomSheetProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    exitTimeout = _useState2[0],
    setExitTimeout = _useState2[1];
  var _useState3 = useState(!open),
    _useState4 = _slicedToArray(_useState3, 2),
    exited = _useState4[0],
    setExited = _useState4[1];
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KEY_NAMES.ESCAPE) {
      event.stopPropagation();
      if (typeof onEscape === 'function') {
        onEscape(event);
      }
      if (!ignoreEscape && typeof onDismiss === 'function') {
        onDismiss();
      }
    }
  };
  useEffect(function () {
    if (open) {
      setExited(!open);
      if (exitTimeout) {
        clearTimeout(exitTimeout);
      }
    } else if (!exited) {
      setExitTimeout(setTimeout(function () {
        setExited(!open);
      }, 250));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs("div", {
    className: cn({
      invisible: exited
    }, 'fixed inset-0 z-dialog max-h-screen', rootClassName),
    role: "dialog",
    children: [hideBackdrop ? null : /*#__PURE__*/_jsx("div", {
      className: cn('fixed inset-0 bg-base-main -z-1', open ? 'opacity-80' : 'opacity-0', backdropClassName),
      style: {
        transition: transition('opacity')
      },
      onClick: ignoreBackdropClick ? undefined : onDismiss,
      onKeyDown: handleKeyDown,
      tabIndex: -1
    }), /*#__PURE__*/_jsx(FocusLock, {
      disabled: disabledFocusLock || open,
      returnFocus: true,
      className: "fixed left-0 right-0 bottom-0 ".concat(dark ? 'bg-base-dark' : 'bg-white'),
      children: /*#__PURE__*/_jsx(RemoveScroll, {
        enabled: !disabledScrollLock && open,
        forwardProps: true,
        children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
          className: cn("w-full max-h-full ".concat(dark ? 'bg-base-lighter-24' : 'bg-gray-lighter', " focus:outline-none"), open ? 'opacity-1' : 'opacity-0', className),
          style: _objectSpread({
            transform: "translateY(".concat(open ? 0 : 100, "%)"),
            transition: transition(['transform', 'opacity'], 250)
          }, style),
          onKeyDown: handleKeyDown
        }, bottomSheetProps), htmlProps), {}, {
          children: children
        }))
      })
    })]
  }), document.body);
};
export default BottomSheet;